import { theme } from '~/theme';

export const useSxStyles = () => {
  const legacyFixedWidth = '1170px';

  return {
    contentLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr',
      minHeight: '100%',
      width: '100%',
      minWidth: legacyFixedWidth,
    },
    top: {
      display: 'grid',
      gridTemplateColumns: ' 640px auto',
      padding: theme.spacing(1, 2, 2),
    },
    actions: {
      paddingTop: theme.spacing(1.5),
    },
  };
};
